<template>
  <div v-if="model.reportId" class="report" ref="imageDom">
    <report-compression v-if="showCompressionReport" class="report-compression" :model="model" :patientBMI="patientBMI"
      :userName="model.initialPatientName" :showBreathWaveChart="showBreathWaveChart" @onInputInput="onInputInput"
      @onSaveClick="onSaveClick" @onEditorSaveClick="onEditorSaveClick" @onPrintClick="onPrintClick"
      @onShareClick="onShareClick" @onDownloadPNGClick="onDownloadPNGClick" @onDownloadPDFClick="onDownloadPDFClick" />

    <div v-else class="report-container">
      <report-title :model="model" 
        :showRawDataButton="isShowRawDataButton" 
        :reportData="reportData" 
        @onDownloadPDFClick="onDownloadPDFClick" 
        @onDownloadPNGClick="onDownloadPNGClick"
        @onPrintClick="onPrintClick" 
        @onShareClick="onShareClick"
        @onRawDataDownloadClick="onRawDataDownloadClick"></report-title>
      <user-info :reportDetailModel="userInfoModel" @onEditUserInfoSucceed="onUserInfoUpdated"></user-info>
      <!-- <section-header title="数据摘要"></section-header> -->
      <data-abstract :model="model"></data-abstract>
      <!-- <section-header title="睡眠时间统计"></section-header> -->
      <sleep-time-statistics :model="model"></sleep-time-statistics>

      <!-- <section-header title="睡眠分期时间"></section-header> -->
      <sleep-period :model="model"></sleep-period>
      <!-- <section-header :title="sleepBreathEventTitle"></section-header> -->
      <sleep-event :model="model"></sleep-event>

      <!-- <section-header title="脉率统计"></section-header> -->
      <heart-statistics :model="model"></heart-statistics>
      <!-- <section-header title="血氧统计"></section-header> -->
      <blood-oxygen :model="model"></blood-oxygen>
      <!-- <heart-statistics :model="model"></heart-statistics> -->

      <!-- 打印预览第一页 -->
      <div style="page-break-after: always"></div>


      <div>
        <section-blood-oxygen class="first-content-section" :reportDetailModel="model"></section-blood-oxygen>
        <!-- <snoring-statistics :model="model"></snoring-statistics> -->
        <micro-awareness :model="model"></micro-awareness>
        <editor style="z-index: 0" :model="model" @onSaveClick="onEditorSaveClick"></editor>
        <reviewer-info :model="model" @onInputInput="onInputInput" @onSaveClick="onSaveClick" />
        <div style="page-break-after: always"></div>

        <section-header title="趋势图"></section-header>
        <line-area-chart title="睡眠结构" :model="model" :timeTickArray="model.timeTickArray">
        </line-area-chart>

        
        <line-chart v-if="bloodOxygenChartData && bloodOxygenChartData.length > 0" title="血氧饱和度"
          :dataArray="bloodOxygenChartData" :timeTickArray="model.timeTickArray">

        </line-chart>
        <line-chart v-if="pulseChartDataArray && pulseChartDataArray.length > 0" title="脉率"
          :dataArray="pulseChartDataArray" :timeTickArray="model.timeTickArray">
        </line-chart>
        <line-chart v-if="microChartDataArray && microChartDataArray.length > 0" title="微觉醒"
          :dataArray="microChartDataArray" :timeTickArray="model.timeTickArray">
        </line-chart>
        <line-chart title="中枢型呼吸暂停" :dataArray="centralData" :timeTickArray="model.timeTickArray">
        </line-chart>
        <line-chart title="阻塞型呼吸暂停" :dataArray="obstructiveData" :timeTickArray="model.timeTickArray">
        </line-chart>
        <div style="page-break-after: always"></div>
        <line-chart title="混合型呼吸暂停" :dataArray="mixedData" :timeTickArray="model.timeTickArray">
        </line-chart>
        <line-chart title="低通气" :dataArray="hypopneaData" :timeTickArray="model.timeTickArray">
        </line-chart>
        <line-chart title="氧减事件(秒)" :dataArray="desaturationData" :timeTickArray="model.timeTickArray">
        </line-chart>
        <area-chart title="体动图" :dataArray="moveRangeChartDataArray" :timeTickArray="model.timeTickArray"
          :sn="model.ringSN">
        </area-chart>
        <line-chart v-if="positionsChartDataArray && positionsChartDataArray.length > 0" title="体位图" :dataArray="positionsChartDataArray" :timeTickArray="model.timeTickArray">
        </line-chart>
      </div>



      <report-bottom v-if="model.showReportBottom" :model="model" />


    </div>
    <warning-hint class="report-warning no-print" v-if="showWarning" @close="onWarningClose"></warning-hint>

    <!-- AI会话悬浮按钮 -->
    <div v-if="showAIFloatingButton" class="ai-chat-floating-button" @click="openAIChat" title="AI医疗助手">
      <svg class="ai-icon" viewBox="0 0 24 24" width="32" height="32" fill="none">
        <circle cx="12" cy="12" r="10" fill="url(#aiGradient)" />
        <rect x="7" y="9" width="10" height="6" rx="3" fill="#fff" />
        <circle cx="9.5" cy="12" r="1" fill="#4F8CFF" />
        <circle cx="14.5" cy="12" r="1" fill="#4F8CFF" />
        <rect x="10.5" y="15" width="3" height="1" rx="0.5" fill="#4F8CFF" />
        <rect x="11" y="6" width="2" height="2" rx="1" fill="#fff" />
        <defs>
          <linearGradient id="aiGradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
            <stop stop-color="#4F8CFF" />
            <stop offset="1" stop-color="#6EE7B7" />
          </linearGradient>
        </defs>
      </svg>
      <span class="ai-chat-label">AI助手</span>
    </div>

    <!-- AI会话对话框 -->
    <div v-if="showAIChatDialog" :class="['ai-chat-panel', 'draggable-dialog', { 'zoomed': isZoomed }]"
      :style="{ right: dialogX + 'px', bottom: dialogY + 'px' }" @mousedown="handleDialogMouseDown">
      <!-- 简化后的聊天容器，包含关闭按钮 -->
      <div class="ai-chat-container-simplified">
        <!-- 右上角关闭按钮 -->
        <div class="ai-close-button" @click="showAIChatDialog = false" title="关闭">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </div>

        <!-- 放大镜按钮 -->
        <div class="ai-zoom-button" @click="toggleZoom" :title="isZoomed ? '缩小' : '放大'">
          <svg v-if="!isZoomed" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <!-- 放大镜图标 -->
            <path
              d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            <path d="m12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" />
          </svg>
          <svg v-else viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <!-- 缩小图标 -->
            <path
              d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            <path d="M7 9v1h5V9H7z" />
          </svg>
        </div>

        <!-- AI头部信息 -->
        <div class="ai-chat-dialog-header-simplified">
          <div class="ai-avatar">
            <svg viewBox="0 0 40 40" width="40" height="40">
              <circle cx="20" cy="20" r="20" fill="url(#aiAvatarGradient)" />
              <ellipse cx="20" cy="24" rx="10" ry="8" fill="#fff" />
              <circle cx="16" cy="22" r="2" fill="#4F8CFF" />
              <circle cx="24" cy="22" r="2" fill="#4F8CFF" />
              <rect x="18" y="27" width="4" height="2" rx="1" fill="#4F8CFF" />
              <defs>
                <linearGradient id="aiAvatarGradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#4F8CFF" />
                  <stop offset="1" stop-color="#6EE7B7" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="ai-title-area">
            <div class="ai-title">AI医疗助手</div>
            <div class="ai-desc">智能问答 · 专业守护</div>
          </div>
          <div class="ai-header-controls">
            <!-- 在头部区域右侧添加控制按钮 -->
          </div>
        </div>

        <!-- 聊天消息列表 -->
        <div class="chat-messages" ref="chatMessagesRef">
          <div v-for="(message, index) in chatMessages" :key="index" :class="['message', message.type]">
            <div class="message-content">
              <!-- 复制按钮 - 只对AI和系统消息显示 -->
              <div v-if="message.type === 'ai' || message.type === 'system'" class="copy-button"
                @click="copyMessage(message.text)" title="复制内容">
                <i class="el-icon-copy-document" style="font-family: element-icons !important;"></i>
                <span>复制</span>
              </div>

              <!-- AI和系统消息支持Markdown显示 -->
              <div v-if="message.type === 'ai' || message.type === 'system'" class="message-rich-text"
                v-html="parseMarkdown(message.text)"></div>
              <!-- 普通文本消息 -->
              <div v-else class="message-text">{{ message.text }}</div>
              <div class="message-time">{{ message.time }}</div>
            </div>
          </div>
          <div v-if="isAITyping" class="message ai">
            <div class="message-content">
              <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>

        <!-- 常见问题快捷按钮 -->
        <div class="common-questions">
          <div class="questions-title">💡 常见咨询问题：</div>
          <div class="questions-buttons">
            <button v-for="question in commonQuestions" :key="question.id" @click="handleQuickQuestion(question.prompt)"
              :disabled="isAITyping" class="question-button" :title="question.description">
              <span class="question-icon">{{ question.icon }}</span>
              <span class="question-text">{{ question.label }}</span>
            </button>
          </div>
        </div>

        <!-- 输入区域 -->
        <div class="chat-input-area">
          <div class="input-wrapper">
            <input v-model="currentMessage" type="text" placeholder="请输入您的问题..." @keyup.enter="sendMessage"
              :disabled="isAITyping" class="chat-input" />
            <button type="button" @click="sendMessage" :disabled="isAITyping || !currentMessage.trim()"
              class="send-button">
              发送
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ReportTitle from "@c/m11b-report-detail/report-title.vue";
import UserInfo from "@c/report-detail/single-blood-oxygen-report/new-section/m01b-user-info.vue";
import ReviewerInfo from "@c/m11b-report-detail/reviewer-info/reviewer-info.vue";
import SectionHeader from "@c/report-detail/section-header.vue";
import DataAbstract from "@c/m11b-report-detail/data-abstract/data-abstract.vue";
import SleepTimeStatistics from "@c/m11b-report-detail/sleep-time-statistics.vue";
import SleepEvent from "@c/m11b-report-detail/sleep-event/sleep-event.vue";
import SleepPeriod from "@c/m11b-report-detail/sleep-period/sleep-period.vue";
import BloodOxygen from "@c/m11b-report-detail/blood-oxygen/blood-oxygen.vue";
import HeartStatistics from "@c/m11b-report-detail/heart-statistics.vue";
import SnoringStatistics from "@c/m11b-report-detail/snoring-statistics.vue";
import MicroAwareness from "@c/m11b-report-detail/micro-awareness.vue";
import AhiBar from "@c/report-detail/ahi-bar.vue";
import Editor from "@c/m11b-report-detail/editor.vue";
import ReportBottom from "@c/report-detail/report-bottom.vue";
import { ReportModel } from "./report-model.js";
import { ReportPreviewTool } from "@js/report-preview-tool.js";

import LineChart from "@c/m11b-report-detail/sleep-chart/line-chart.vue";
import LineAreaChart from "@c/m11b-report-detail/sleep-chart/line-area-chart.vue";
import AreaChart from "@c/m11b-report-detail/sleep-chart/area-chart.vue";
import DoubleLineChart from "@c/m11b-report-detail/sleep-chart/double-line-chart.vue";
import DoubleLineAreaChart from "@c/m11b-report-detail/sleep-chart/double-line-area-chart.vue";
import CombineChart from "@c/m11b-report-detail/sleep-chart/combine-chart.vue";
import { DateTool } from "@js/date-tool.js";
import WarningHint from "@c/report-detail/warning/invalid-bloodoxygen-warning.vue";
import { MessageBox } from "element-ui";
import appHandler from "@js/appHandler.js";
import reportCompression from "@c/report-detail/report-compression/report-compression.vue";
import dayjs from "dayjs";
import SectionBloodOxygen from "@c/m11b-report-detail/oxygen-data/section-blood-oxygen.vue";


const CHART_ORDERS = {
  default: [
    "bloodOxygenPulse", // （血氧/脉率组合图）或者是（睡眠血氧趋势+睡眠脉率趋势）
    "breath", // 呼吸趋势
    "periodEvent", // 分期/事件组合图
    "moveRate", // 体动占比
    "moveRange", // 体动幅度
  ],
  [REPORT_TEMPLATE.沧州市中心医院]: [
    "bloodOxygen", // 血氧趋势
    "period", // 睡眠分期趋势
    "breathEvent", // 睡眠呼吸事件
    "moveRange", // 体动幅度
    "pulse", // 脉率趋势
    "breath", // 呼吸趋势
    "moveRate", // 体动占比
  ],
  [REPORT_TEMPLATE.南京医科大学附属明基医院]: [
    "bloodOxygen", // 血氧趋势
    "pulse", // 脉率趋势
    "period", // 睡眠分期趋势
  ],
};

export default {
  components: {
    ReportTitle,
    UserInfo,
    SectionHeader,
    DataAbstract,
    SleepTimeStatistics,
    SleepEvent,
    SleepPeriod,
    BloodOxygen,

    AhiBar,
    Editor,
    ReportBottom,
    LineChart,
    AreaChart,
    DoubleLineChart,
    WarningHint,
    reportCompression,
    LineAreaChart,
    DoubleLineAreaChart,
    CombineChart,
    HeartStatistics,
    ReviewerInfo,
    SectionBloodOxygen,
    SnoringStatistics,
    MicroAwareness,
  },
  data() {
    return {
      pageNum: 1,
      model: {},
      bloodOxygenChartData: null, // 改为null，避免空数组触发watch
      pulseChartDataArray: [],
      microChartDataArray: [],
      breathEventChartDataArray: [],
      hypopneaData: [],
      centralData: [],
      mixedData: [],
      obstructiveData: [],
      desaturationData: [],
      moveRangeChartDataArray: [],
      positionsChartDataArray: [],
      operator: "",
      reviewer: "",
      patientName: "",
      patientHeight: "",
      patientAge: "",
      patientDepartment: "",
      patientGender: "",
      patientWeight: "",
      patientBedNumber: "",
      patientDiagnoseNumber: "",
      patientBMI: "",
      editedConclusion: "",
      mobile: "",
      nasal: "",
      tonsils: "",
      adenoids: "",
      throat: "",
      patientNeckCircumference: "",
      bloodPressure: "",
      showWarning: false, // 默认不显示warning-hint
      pdfUrl: null,
      reportPdfUrl: null,
      reportPngUrl: null,
      reportId: null,
      clickType: null,
      isLoadingPdf: false,
      reportType: "compression",
      qrUrl:
        "https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/file/1706604514090.png",
      showCombineChart: false,
      // AI 会话相关数据
      showAIChatDialog: false,
      chatMessages: [],
      currentMessage: '',
      isAITyping: false,
      sessionId: undefined,
      // 拖拽相关状态
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dialogX: 32, // 初始右边距
      dialogY: 120, // 初始底边距
      // 放大功能相关状态
      isZoomed: false,
      // 常见问题配置
      commonQuestions: [
        {
          id: 'treatment-analysis',
          label: '报告解读',
          icon: '📊',
          prompt: '请基于当前睡眠报告数据，综合分析核心睡眠指标(如睡眠效率、各期睡眠占比、呼吸事件指数等)，并解读其临床意义',
          description: '分析当前治疗效果并提供改进建议'
        },
        {
          id: 'parameter-optimization',
          label: '患者睡眠质量评估',
          icon: '🔧',
          prompt: '根据当前的睡眠监测数据，请对我的整体睡眠质量进行一个量化的评估，并指出最主要的问题和优势所在',
          description: '获取呼吸机参数优化建议'
        },
        {
          id: 'compliance-analysis',
          label: '患者建议',
          icon: '❤️',
          prompt: '请基于当前睡眠报告数据，请提供一套个性化、可执行的健康改善建议，包括生活方式调整和是否需要进一步医疗干预的指导',
          description: '评估患者治疗依从性并提供改善方案'
        },
        // {
        //   id: 'complication-risk',
        //   label: '并发症风险',
        //   icon: '⚠️',
        //   prompt: '识别OSA相关并发症风险',
        //   description: '识别和评估相关并发症风险'
        // },
        // {
        //   id: 'management-plan',
        //   label: '管理方案',
        //   icon: '📋',
        //   prompt: '制定个性化长期管理方案',
        //   description: '制定个性化的长期治疗管理方案'
        // }
      ],
      // 控制AI悬浮按钮显示状态
      showAIFloatingButton: false
    };
  },

  computed: {
    deviceType() {
      return this.$store.getters.deviceType;
    },

    // 判断是否显示原始包下载按钮（仅M11B设备显示）
    isShowRawDataButton() {
      return this.model && this.model.deviceType === 1;
    },

    // 为原始包下载提供报告数据
    reportData() {
      if (!this.model || !this.model.reportNumber) {
        return null;
      }
      return {
        reportNumber: this.model.reportNumber,
        zipFileName: this.model.zipFileName ,
        deviceType: this.model.deviceType
      };
    },

    showCompressionReport() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.北京大学深圳医院呼吸内科睡眠检测中心:
        case REPORT_TEMPLATE.深圳市儿童医院:
        case REPORT_TEMPLATE.文山州人民医院耳鼻喉科睡眠呼吸报告:
        case REPORT_TEMPLATE.温州医科大学附属第二医院:
          return true;
        default:
          return false;
      }
    },
    chartOrder() {

      return (
        CHART_ORDERS[this.model.reportTemplateType] || CHART_ORDERS.default
      );
    },
    showBreathWaveChart() {
      return this.showCombineChart && this.model.breathWaveShow;
    },
    sleepBreathEventTitle() {
      if (this.model.reportTemplateType == REPORT_TEMPLATE.佛山复星禅城医院儿科二区) {
        return "睡眠呼吸事件（胸腹+口鼻）";
      } else {
        return "睡眠呼吸事件";
      }
    },
    // 为新的用户信息组件提供数据适配器
    userInfoModel() {
      if (!this.model || !this.model.reportId) {
        return {
          reportId: null,
          nameStr: '',
          genderStr: '',
          ageStr: '',
          heightStr: '',
          weightStr: '',
          bmiStr: '',
          medicalRecordNumber: '',
          sn: '',
          deviceNumber: '',
          bedNumber: '',
          doctorName: '',
          reportUser: {
            name: '',
            sex: '',
            age: '',
            height: '',
            weight: '',
            bedNumber: '',
            medicalRecordNumber: '',
            doctorName: '',
            birthday: null
          }
        }
      }

      // 计算年龄（从生日计算）
      const calculateAge = (birthday) => {
        if (!birthday) return this.model.initialPatientAge || '';
        const today = new Date();
        const birthDate = new Date(birthday);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age.toString();
      };

      // 计算BMI
      const calculateBMI = (height, weight) => {
        if (!height || !weight) return this.patientBMI || '';
        const h = parseFloat(height) / 100; // 转换为米
        const w = parseFloat(weight);
        if (h > 0 && w > 0) {
          return (w / (h * h)).toFixed(1);
        }
        return '';
      };

      // 格式化出生日期
      const formatBirthday = (birthday) => {
        if (!birthday) return '';
        return dayjs(birthday).format('YYYY年MM月DD日');
      };
      return {
        reportId: this.model.reportId,
        nameStr: this.model.initialPatientName,
        genderStr: this.model.initialPatientGender,
        ageStr: calculateAge(this.model.initialPatientBirthday) || this.model.initialPatientAge,
        birthdayStr: formatBirthday(this.model.initialPatientBirthday),
        heightStr: (this.model.initialPatientHeight ) + 'cm',
        weightStr: (this.model.initialPatientWeight) + 'kg',
        bmiStr: calculateBMI(this.model.initialPatientHeight, this.model.initialPatientWeight),
        medicalRecordNumber: this.model.initialPatientDiagnoseNumber,
        unitStr: this.model.unitStr,
        mobileStr: this.model.initInitialMobile,
        neckCircumferenceStr: this.model.neckCircumferenceStr,
        waistCircumferenceStr: this.model.waistCircumferenceStr,
        chestCircumferenceStr: this.model.chestCircumferenceStr,
        hipCircumferenceStr: this.model.hipCircumferenceStr,
        reportUser: {
          name: this.model.initialPatientName || '',
          sex: this.model.initialPatientGender === '男' ? 1 : 2,
          age: calculateAge(this.model.initialPatientBirthday) || this.model.initialPatientAge || '',
          height: this.model.initialPatientHeight || '',
          weight: this.model.initialPatientWeight || '',
          medicalRecordNumber: this.model.initialPatientDiagnoseNumber || '',
          mobile: this.model.initInitialMobile || '',
          neckCircumference: this.model.initialPatientNeckCircumference || '',
          waistCircumference: '',
          chestCircumference: '',
          hipCircumference: '',
          birthday: this.model.initialPatientBirthday || null
        }
      }
    },
  },

  beforeDestroy() {
    this.model = null;
    // 清理 store 中的 deviceType
    this.$store.commit('clearDeviceType');
    // 清理可能残留的 sessionStorage
    sessionStorage.removeItem('report_deviceType');
  },
  watch: {
    model(newValue) {
      this.operator = newValue.initialOperator;
      this.reviewer = newValue.initialReviewer;
      this.patientName = newValue.initialPatientName;
      this.patientHeight = newValue.initialPatientHeight;
      this.patientAge = newValue.initialPatientAge;
      this.patientDepartment = newValue.initialPatientDepartment;
      this.patientGender = newValue.initialPatientGender;
      this.patientWeight = newValue.initialPatientWeight;
      this.patientBedNumber = newValue.initialPatientBedNumber;
      this.patientDiagnoseNumber = newValue.initialPatientDiagnoseNumber;
      this.patientBMI = newValue.initialPatientBMI;
      this.editedConclusion = newValue.conclusion;
      this.mobile = newValue.initInitialMobile;
    },

    patientHeight() {
      this.computeBMIValue();
    },

    patientWeight() {
      this.computeBMIValue();
    },
  },
  beforeCreate() {
    if (window.name == "") {
      this.$store.state.loadingShow = true;
      // 在首次进入页面时我们给window.name设置一个固定值(isRefresh)
      window.name = "isRefresh";
    } else if (window.name == "isRefresh") {
      this.$store.state.loadingShow = true;
    }
  },

  created() {
    // 检查URL参数来控制AI悬浮按钮显示
    const query = this.$router.history.current.query;
    if (query.showAIFloatingButton === 'true') {
      this.showAIFloatingButton = true;
    }

    // 从 sessionStorage 获取 deviceType
    const deviceType = sessionStorage.getItem('report_deviceType');

    if (deviceType !== null) {
      this.$store.commit('saveDeviceType', parseInt(deviceType));
      // 使用后立即清理
      sessionStorage.removeItem('report_deviceType');
    }

    this.reportDetailRequest();
  },

  methods: {
    // 处理用户信息更新成功事件
    onUserInfoUpdated() {
      // 重新获取报告数据以更新显示
      this.reportDetailRequest();
    },

    whatOS() {
      let ran = navigator.userAgent;
      let isAndroid = ran.indexOf("Android") > -1 || ran.indexOf("Linux") > -1;
      let isIOS = !!ran.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "web";
      }
    },

    onWarningClose(value) {
      this.showWarning = value;
    },
    onDownloadPDFClick() {
      this.clickType = "pdf";
      this.reportGenerateUrl();
    },
    onDownloadPNGClick() {
      const currentQuery = { ...this.$route.query };
      this.$router.replace({
        path: this.$route.path,
        query: currentQuery
      });

      this.clickType = "png";
      // 使用 setTimeout 确保DOM更新完成后再执行下载
      this.$nextTick(() => {
        setTimeout(() => {
          this.reportGenerateUrl().finally(() => {
            // 下载完成后恢复显示AI悬浮按钮

            // setTimeout(() => {
            //   this.showAIFloatingButton = true;
            // }, 1000); // 延迟1秒恢复显示，确保下载流程完全结束
          });
        }, 100); // 短暂延迟以确保隐藏效果生效
      });
    },

    async reportGenerateUrl() {
      const reportInfo = this.$router.history.current.query;
      let createTimeStr = DateTool.timestampToStr(
        reportInfo.reportCreateTime,
        "M月D日 h：m"
      );
      try {
        const params = {
          reportId: this.reportId,
        };
        const response = await this.$api.reportGenerateUrl(params);
        this.reportPdfUrl = response.pdfUrl;
        this.reportPngUrl = response.pngUrl;
        if (this.clickType == "pdf") {
          if (this.whatOS() == "web") {
            ReportPreviewTool.downloadReport(
              reportInfo.userName,
              this.reportPdfUrl,
              reportInfo.reportCreateTime
            );
          } else {
            appHandler.sendMsg({
              type: "DownloadPDF",
              pngUrl: this.reportPngUrl,
              pdfUrl: this.reportPdfUrl,
            });
          }
        } else if (this.clickType == "png") {
          if (this.whatOS() == "web") {
            // 为PNG下载URL添加showAIFloatingButton=false参数
            let pngUrl = this.reportPngUrl;
            ReportPreviewTool.downloadImage(
              reportInfo.userName,
              createTimeStr,
              pngUrl
            );
          } else {
            appHandler.sendMsg({
              type: "DownloadPNG",
              pngUrl: this.reportPngUrl,
              pdfUrl: this.reportPdfUrl,
            });
          }
        } else if (this.clickType == "print") {
          this.onPrintClick();
        } else {
          this.onShareClick();
        }
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    onPrintClick() {
      this.clickType = "print";
      if (this.whatOS() == "web") {
        // CSS会自动处理页码，不需要手动添加
        window.print();
      } else {
        if (this.reportPdfUrl == null || this.reportPngUrl == null) {
          this.reportGenerateUrl();
        } else {
          appHandler.sendMsg({
            type: "Print",
            pngUrl: this.reportPngUrl,
            pdfUrl: this.reportPdfUrl,
          });
        }
      }
    },

    async onShareClick() {
      this.clickType = "share";
      if (this.whatOS() == "web") {
        try {
          const reportInfo = this.$router.history.current.query;
          let title = `【NPPV治疗服务睡眠监测报告${this.model?.createDate || ""
            }${reportInfo.userName}】`;
          let url = "";
          await this.generatePdf();
          url = this.pdfUrl;
          MessageBox.alert(title + url, "分享内容", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$copyText(title + url);
              this.$toast.showGreen(MSG.copyToClipboardSuccess);
            },
          });
        } catch (error) {
          this.$toast.showRed(error);
        }
      } else {
        if (this.reportPdfUrl == null || this.reportPngUrl == null) {
          this.reportGenerateUrl();
        } else {
          appHandler.sendMsg({
            type: "Share",
            pngUrl: this.reportPngUrl,
            pdfUrl: this.reportPdfUrl,
          });
        }
      }
    },

    async onRawDataDownloadClick() {
      if (!this.reportData || !this.reportData.reportNumber) {
        this.$toast.showRed('报告数据不完整');
        return;
      }

      try {
        const params = {
          reportNumber: this.reportData.reportNumber
        };

        const response = await this.$api.downloadM11bRawData(params);
        if (!response || !response.data) {
          throw new Error('下载响应为空');
        }

        const blob = new Blob([response.data], {
          type: "application/zip"
        });

        if (blob.size === 0) {
          throw new Error('下载文件为空');
        }

        const filename = `${this.reportData.zipFileName || this.reportData.reportNumber}.zip`;

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$toast.showGreen('下载成功');

      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async generatePdf() {
      if (this.isLoadingPdf) {
        return;
      }
      this.isLoadingPdf = true;
      try {
        let downloadURL = await this.$api.generatePdf({
          url: window.location.href,
          inline: true,
        });
        this.pdfUrl = downloadURL;
      } catch (error) {
      } finally {
        this.isLoadingPdf = false;
      }
    },

    onSaveClick() {
      this.submitRequest();
    },

    onInputInput(title, value) {
      switch (title) {
        case "报告":
          this.operator = value;
          break;
        case "审核":
          this.reviewer = value;
          break;
        case "医师":
          this.reviewer = value;
          break;
        case "姓名":
          this.patientName = value;
          break;
        case "身高(cm)":
          this.patientHeight = value;
          break;
        case "年龄":
          this.patientAge = value;
          break;
        case "科室":
          this.patientDepartment = value;
          break;
        case "性别":
          this.patientGender = value;
          break;
        case "体重(Kg)":
          this.patientWeight = value;
          break;
        case "床位号":
          this.patientBedNumber = value;
          break;
        case "病案号":
          this.patientDiagnoseNumber = value;
          break;
        case "住院号":
          this.patientDiagnoseNumber = value;
          break;
        case "登记号":
          this.patientDiagnoseNumber = value;
          break;
        case "手机号":
          this.mobile = value;
          break;
        case "鼻":
          this.nasal = value;
          break;
        case "扁桃体":
          this.tonsils = value;
          break;
        case "腺样体":
          this.adenoids = value;
          break;
        case "咽喉":
          this.throat = value;
          break;
        case "年龄(岁)":
          this.patientAge = value;
          break;
        case "档案号":
          this.patientDiagnoseNumber = value;
          break;
        case "颈围":
          this.patientNeckCircumference = value;
          break;
        case "血压":
          this.bloodPressure = value;
          break;
        case "病区床号":
          this.patientBedNumber = value;
          break;

        default:
          break;
      }
    },

    onEditorSaveClick(html) {
      this.editedConclusion = html;
      this.submitRequest();
    },

    computeBMIValue() {
      let meterHeight = 0;
      if (this.patientHeight) {
        meterHeight = Number.parseFloat(this.patientHeight) / 100;
      } else {
        meterHeight = Number.parseFloat(this.initialPatientHeight) / 100;
      }
      let kgWeight = 0;
      if (this.patientWeight) {
        kgWeight = Number.parseFloat(this.patientWeight);
      } else {
        kgWeight = Number.parseFloat(this.initialPatientWeight);
      }
      const rawBMI = kgWeight / (meterHeight * meterHeight);
      const BMIStr = `${Number(rawBMI.toFixed(1))}`;
      this.patientBMI = BMIStr == "NaN" ? "" : BMIStr;
    },

    async reportDetailRequest() {
      try {
        const params = {
          reportNumber: this.$router.history.current.query.reportURL,
        };
        const response = await this.$api.getSleepReportDetail(params);
        this.reportId = response.reportInfo.id;
        this.reportPdfUrl = response.reportInfo.pdfUrl;
        this.reportPngUrl = response.reportInfo.pngUrl;
        if (response.reportInfo.complete == "缺少血氧") {
          this.showWarning = true;
        }
        this.model = new ReportModel(response);

        // 异步初始化timeTickArray
        await this.model.initTimeTickArray();

        // 异步获取血氧图表数据
        this.bloodOxygenChartData = await this.model.bloodOxygenChartDataArray();
        this.pulseChartDataArray = await this.model.pulseChartDataArray()
        this.microChartDataArray = await this.model.microChartDataArray()
        this.breathEventChartDataArray = await this.model.breathEventChartDataArray()
      
        
        // 使用JSON转换来解除响应式包装，确保传递纯数据对象
        this.hypopneaData = this.breathEventChartDataArray?.hypopnea ? JSON.parse(JSON.stringify(this.breathEventChartDataArray.hypopnea)) : []
        this.mixedData = this.breathEventChartDataArray?.mixed ? JSON.parse(JSON.stringify(this.breathEventChartDataArray.mixed)) : []
        this.centralData = this.breathEventChartDataArray?.central ? JSON.parse(JSON.stringify(this.breathEventChartDataArray.central)) : []
        this.obstructiveData = this.breathEventChartDataArray?.obstructive ? JSON.parse(JSON.stringify(this.breathEventChartDataArray.obstructive)) : []
        this.desaturationData = this.breathEventChartDataArray?.desaturation ? JSON.parse(JSON.stringify(this.breathEventChartDataArray.desaturation)) : []
        
        
        const moveRangeData = await this.model.moveRangeChartDataArray()
        this.moveRangeChartDataArray = moveRangeData ? JSON.parse(JSON.stringify(moveRangeData)) : []
        const positionsData = await this.model.positionsChartDataArray()
        this.positionsChartDataArray = positionsData ? JSON.parse(JSON.stringify(positionsData)) : []

        // 确保数据更新后重新渲染
        this.$forceUpdate();

        if (this.model.breathWaveShow) {
          this.getSleepReportBreathWave();
        }
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async submitRequest() {
      try {
        const params = {
          reportNumber: this.$router.history.current.query.reportURL,
          // age: this.patientAge,
          // trueName: this.patientName,
          // sex: this.patientGender,
          // height: this.patientHeight,
          // weight: this.patientWeight,
          // bmi: this.patientBMI,
          // mzh: this.patientDiagnoseNumber,
          // bch: this.patientBedNumber,
          department: this.patientDepartment,
          suggest: this.editedConclusion,
          // report: this.operator,
          examine: this.reviewer,
          // mobile: this.mobile,
          // nasal: this.nasal,
          // tonsils: this.tonsils,
          // adenoids: this.adenoids,
          // throat: this.throat,
          // neckCircumference: this.patientNeckCircumference,
          // bloodPressure: this.bloodPressure,
        };
        await this.$api.editReportDetail(params);
        this.$toast.showGreen(MSG.reportEditSucceed);
        this.reportDetailRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },
    //获取呼吸波详情
    async getSleepReportBreathWave() {
      try {
        const params = {
          reportId: this.reportId,
        };
        const response = await this.$api.getSleepReportBreathWave(params);
        if (response) {
          this.model.setbreathWaveDetail(response);
          this.showCombineChart = true;
        }
      } catch (error) {
      }
    },
    shouldAddPageBreak(index) {
      // 根据图表类型和索引位置决定是否添加分页符
      const chartType = this.chartOrder[index];
      const nextChartType = this.chartOrder[index + 1];

      // 如果是默认模板
      if (this.chartOrder === CHART_ORDERS.default) {
        // 在呼吸趋势图后添加分页
        if (chartType === "bloodOxygenPulse") {
          return this.model.isPage2BreakAtPosition1;
        }

        // 在分期/事件组合图后添加分页
        if (chartType === "breath") {
          return !this.model.isPage2BreakAtPosition1;
        }

        // 在体动占比图后添加分页
        if (chartType === "moveRate") {
          return this.model.isPage3BreakAtPosition1;
        }

        // 在体动幅度图后添加分页
        if (chartType === "moveRange") {
          return !this.model.isPage3BreakAtPosition1;
        }
      }
      // 如果是沧州市中心医院模板
      else if (
        this.model.reportTemplateType === REPORT_TEMPLATE.沧州市中心医院
      ) {
        // 血氧趋势后添加分页
        if (chartType === "period") {
          return true;
        }
        // 睡眠呼吸事件后添加分页
        if (chartType === "breath") {
          return true;
        }
      } else if (
        this.model.reportTemplateType ===
        REPORT_TEMPLATE.南京医科大学附属明基医院
      ) {
        // 脉率趋势后添加分页
        if (chartType === "pulse") {
          return true;
        }
      }
      return false;
    },

    // AI 会话相关方法
    async openAIChat() {
      // 显示对话框
      this.showAIChatDialog = true

      // 只有在首次打开或者没有sessionId时才初始化会话
      if (!this.sessionId) {
        try {
          // 获取AI系统提示 - 这里使用reportId替代servicePackageId
          const systemPromptData = await this.$api.getAiSystemPrompt({
            reportId: this.reportId,
          })

          // 创建AI会话并获取sessionId
          const createSessionData = await this.$api.getAiCreate({
            reportId: this.reportId,
          })

          // 保存sessionId用于后续聊天
          this.sessionId = createSessionData.sessionId

          // 如果是第一次打开，添加系统提示信息和欢迎消息
          if (this.chatMessages.length === 0) {
            // 首先显示系统提示信息（报告详细信息）
            // 检查不同的数据格式
            let systemPromptText = ''
            if (typeof systemPromptData === 'string') {
              // 直接返回字符串
              systemPromptText = systemPromptData
            } else if (systemPromptData.data?.systemPrompt) {
              // 嵌套在data.systemPrompt中
              systemPromptText = systemPromptData.data.systemPrompt
            } else if (systemPromptData.systemPrompt) {
              // 直接在systemPrompt字段中
              systemPromptText = systemPromptData.systemPrompt
            }

            if (systemPromptText && systemPromptText.trim()) {
              this.chatMessages.push({
                text: `📋 **AI系统提示词配置**\n\n${systemPromptText}`,
                type: 'system',
                time: this.getCurrentTime()
              })
            } else {
            }

            // 然后添加欢迎消息
            this.chatMessages.push({
              text: '您好！我是AI医疗助手，基于上述患者信息，我可以帮助您解答关于睡眠监测报告的专业问题。请问有什么可以帮助您的吗？',
              type: 'ai',
              time: this.getCurrentTime()
            })
          }

        } catch (error) {
          // 如果初始化失败，显示错误消息
          this.chatMessages = [{
            text: '抱歉，AI助手初始化失败，请稍后重试。',
            type: 'ai',
            time: this.getCurrentTime()
          }]
        }
      }

      // 滚动到底部
      setTimeout(() => {
        this.scrollToBottom()
      }, 100)
    },

    // 处理快捷问题点击
    async handleQuickQuestion(prompt) {
      if (this.isAITyping) return

      // 添加用户消息
      this.chatMessages.push({
        text: prompt,
        type: 'user',
        time: this.getCurrentTime()
      })
      // 滚动到底部
      this.scrollToBottom()

      // 获取AI回复
      await this.getAIReply(prompt)
    },

    // 发送消息
    async sendMessage() {
      if (!this.currentMessage.trim() || this.isAITyping) return

      // 添加用户消息
      this.chatMessages.push({
        text: this.currentMessage,
        type: 'user',
        time: this.getCurrentTime()
      })

      const userMessage = this.currentMessage
      this.currentMessage = ''

      // 滚动到底部
      this.scrollToBottom()

      // 获取AI回复
      await this.getAIReply(userMessage)
    },

    // 获取当前时间
    getCurrentTime() {
      const now = new Date()
      return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`
    },

    // 滚动到底部
    scrollToBottom() {
      // 只有在对话框可见时才滚动
      if (this.showAIChatDialog) {
        setTimeout(() => {
          if (this.$refs.chatMessagesRef) {
            this.$refs.chatMessagesRef.scrollTop = this.$refs.chatMessagesRef.scrollHeight
          }
        }, 100)
      }
    },

    // AI聊天回复 - 使用流式接口
    async getAIReply(userMessage) {
      this.isAITyping = true

      // 先添加一个空的AI消息，用于流式更新
      const messageIndex = this.chatMessages.length
      this.chatMessages.push({
        text: '',
        type: 'ai',
        time: this.getCurrentTime()
      })

      try {
        // 检查是否有sessionId
        if (!this.sessionId) {
          throw new Error('会话未初始化，请重新打开对话框')
        }

        // 获取登录信息
        const loginInfo = JSON.parse(localStorage.getItem('loginInfo') || '{}')
        
        // 直接使用fetch来处理流式响应，因为axios可能无法正确处理SSE
        const response = await fetch(`${process.env.VUE_APP_API_URI_NEW}/sleep/ai/session/chat/stream`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': loginInfo.token || '',
            'uid': loginInfo.uid || '',
            'system': '1'
          },
          body: JSON.stringify({
            sessionId: this.sessionId,
            question: userMessage
          })
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        // 处理流式响应
        await this.handleStreamResponse(response, messageIndex)

      } catch (error) {
        console.error('AI聊天错误:', error)
        let errorMessage = '抱歉，网络连接异常，请稍后重试。'

        // 根据错误类型显示不同的提示
        if (error.message?.includes('timeout')) {
          errorMessage = '请求超时，请稍后重试。'
        } else if (error.message?.includes('500')) {
          errorMessage = '服务器内部错误，请稍后重试。'
        } else if (error.message?.includes('404')) {
          errorMessage = '接口不存在，请联系技术支持。'
        }

        // 更新错误消息
        this.chatMessages[messageIndex].text = errorMessage
      } finally {
        this.isAITyping = false
        this.scrollToBottom()
      }
    },

    // 处理流式响应数据
    async handleStreamResponse(response, messageIndex) {
      try {
        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''

        while (true) {
          const { done, value } = await reader.read()
          if (done) break

          // 解码数据
          const chunk = decoder.decode(value, { stream: true })
          buffer += chunk

          // 处理缓冲区中的完整事件块
          buffer = this.processStreamBuffer(buffer, messageIndex)
        }

        // 处理剩余的缓冲区数据
        if (buffer.trim()) {
          this.processStreamBuffer(buffer + '\n\n', messageIndex)
        }

      } catch (error) {
        console.error('处理流式响应时出错:', error)
        this.chatMessages[messageIndex].text = '处理响应数据时出现错误。'
      }
    },

    // 处理流式缓冲区数据
    processStreamBuffer(buffer, messageIndex) {
      // 标准化换行
      let normalized = buffer.replace(/\r\n/g, '\n')
      let sepIndex

      while ((sepIndex = normalized.indexOf('\n\n')) !== -1) {
        const eventBlock = normalized.slice(0, sepIndex)
        normalized = normalized.slice(sepIndex + 2)
        this.handleStreamEventBlock(eventBlock, messageIndex)
      }

      return normalized // 返回未处理的缓冲区剩余内容
    },

    // 处理流式事件块
    handleStreamEventBlock(block, messageIndex) {
      if (!block.trim()) return

      const lines = block.split('\n')
      let eventType = ''
      const dataParts = []

      for (const line of lines) {
        if (line.startsWith('event:')) {
          eventType = line.substring(6).trim()
        } else if (line.startsWith('data:')) {
          const data = line.substring(5).trim()
          if (data && data !== '[DONE]') {
            dataParts.push(data)
          }
        }
      }

      // 只处理 event: data 的内容
      if (eventType === 'data' && dataParts.length > 0) {
        const content = dataParts.join('')
        
        // 累积消息内容
        if (messageIndex < this.chatMessages.length) {
          this.chatMessages[messageIndex].text += content

          // 实时滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        }
      }
    },


    // 拖拽事件处理函数
    handleDialogMouseDown(event) {
      // 检查点击的元素，避免在交互元素上触发拖拽
      const target = event.target

      // 排除这些元素及其子元素的拖拽
      const excludeSelectors = [
        'input', 'button', 'textarea', 'select', 'a',
        '.send-button', '.chat-input', '.question-button',
        '.ai-close-button', '.ai-zoom-button', '.copy-button', '.event-tag'
      ]

      // 检查是否点击了需要排除的元素
      for (const selector of excludeSelectors) {
        if (target.closest(selector)) {
          return // 不启动拖拽
        }
      }

      this.startDrag(event)
    },

    startDrag(event) {
      event.preventDefault()
      this.isDragging = true
      this.dragStartX = event.clientX
      this.dragStartY = event.clientY

      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },

    onDrag(event) {
      if (!this.isDragging) return

      const deltaX = event.clientX - this.dragStartX
      const deltaY = event.clientY - this.dragStartY

      // 计算新位置
      const newX = this.dialogX - deltaX
      const newY = this.dialogY - deltaY

      // 边界检查，确保对话框不会拖出视窗
      const maxX = window.innerWidth - 520 // 对话框宽度
      const maxY = window.innerHeight - 600 // 对话框高度

      this.dialogX = Math.max(0, Math.min(maxX, newX))
      this.dialogY = Math.max(0, Math.min(maxY, newY))

      this.dragStartX = event.clientX
      this.dragStartY = event.clientY
    },

    stopDrag() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },

    // 放大/缩小切换功能
    toggleZoom() {
      this.isZoomed = !this.isZoomed

      if (this.isZoomed) {
        // 放大时居中显示
        const screenWidth = window.innerWidth
        const screenHeight = window.innerHeight
        const dialogWidth = 800 // 放大后的宽度
        const dialogHeight = 750 // 放大后的高度

        this.dialogX = (screenWidth - dialogWidth) / 2
        this.dialogY = (screenHeight - dialogHeight) / 2
      } else {
        // 缩小时回到原始位置
        this.dialogX = 32
        this.dialogY = 120
      }
    },

    // 获取状态图标的CSS类名
    getStatusIconClass(icon) {
      const iconMap = {
        '✓': 'status-success',
        '✖️': 'status-error',
        '⏳': 'status-pending',
        '🔴': 'status-alert',
        '▶️': 'status-action'
      }
      return iconMap[icon] || 'status-default'
    },

    // Markdown解析器 - 将Markdown格式转换为HTML (优化流式渲染)
    parseMarkdown(text) {
      if (!text) return ''

      // 首先进行HTML转义，防止XSS攻击
      let result = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

      // ===== 第一步：保护代码块，避免被后续处理影响 =====
      const codeBlocks = [];
      let codeBlockIndex = 0;

      // 保护完整的代码块（多行）
      result = result.replace(/```(\w+)?\s*([\s\S]*?)```/g, (match, lang, code) => {
        const language = lang ? ` class="language-${lang}"` : '';
        const placeholder = `__CODE_BLOCK_${codeBlockIndex}__`;
        codeBlocks.push(`<pre class="markdown-code-block"><code${language}>${code.replace(/\n$/, '')}</code></pre>`);
        codeBlockIndex++;
        return placeholder;
      });

      // 保护不完整的代码块
      result = result.replace(/```(\w+)?\s*([\s\S]*)$/g, (match, lang, code) => {
        const language = lang ? ` class="language-${lang}"` : '';
        const placeholder = `__CODE_BLOCK_${codeBlockIndex}__`;
        codeBlocks.push(`<pre class="markdown-code-block incomplete"><code${language}>${code}<span class="cursor-blink">▋</span></code></pre>`);
        codeBlockIndex++;
        return placeholder;
      });

      // ===== 第二步：处理最复杂的组合格式（优先级最高） =====

      // 1. 处理加粗包裹的分割线+井号组合：**---###**内容** (只换行去井号，不转标题)
      result = result.replace(/\*\*-{2,}(#{1,6})\*\*(.*)$/gm, (match, hashes, content) => {
        // 去除内容开头可能的井号和空格
        let cleanContent = content.replace(/^\*\*/, '').replace(/^#+\s*/, '');
        return `<br><br><strong>${cleanContent}</strong>`;
      });

      // 2. 分割线+标题+加粗组合：--###**标题** 或 ---####**标题** (转为标题)
      result = result.replace(/^-{2,}(#{1,6})\*\*(.*?)\*\*(.*)$/gm, (match, hashes, title, extra) => {
        const level = hashes.length;
        return `<br><hr class="markdown-hr"><br><h${level} class="markdown-h${level}"><strong>${title}${extra}</strong></h${level}>`;
      });

      // 3. 分割线+标题（无加粗）：--###标题 或 ---####标题 (转为标题)
      result = result.replace(/^-{2,}(#{1,6})(.+)$/gm, (match, hashes, title) => {
        const level = hashes.length;
        // 去除标题开头的井号符号和空格
        let cleanTitle = title.trim().replace(/^#+\s*/, '');
        return `<br><hr class="markdown-hr"><br><h${level} class="markdown-h${level}"><strong>${cleanTitle}</strong></h${level}>`;
      });

      // 4. 处理纯分割线+井号组合（不在行首，不转标题，只换行去井号）
      result = result.replace(/-{2,}(#{1,6})/g, (match, hashes) => {
        return `<br><br>`;
      });

      // ===== 第三步：处理标题+加粗组合 =====
      // 3. 标题+完整加粗：####**标题**
      result = result.replace(/^(#{1,6})\*\*(.*?)\*\*(.*)$/gm, (match, hashes, title, extra) => {
        const level = hashes.length;
        return `<h${level} class="markdown-h${level}"><strong>${title}${extra}</strong></h${level}>`;
      });

      // 4. 标题+不完整加粗：####**标题
      result = result.replace(/^(#{1,6})\*\*(.*)$/gm, (match, hashes, title) => {
        const level = hashes.length;
        // 检查是否有未闭合的加粗
        const hasClosingBold = title.includes('**');
        if (hasClosingBold) {
          const cleanTitle = title.replace(/\*\*$/, '');
          return `<h${level} class="markdown-h${level}"><strong>${cleanTitle}</strong></h${level}>`;
        } else {
          return `<h${level} class="markdown-h${level}"><strong>${title}<span class="cursor-blink">▋</span></strong></h${level}>`;
        }
      });

      // ===== 第四步：处理普通标题 =====
      result = result
        .replace(/^###### (.*)$/gm, '<h6 class="markdown-h6"><strong>$1</strong></h6>')
        .replace(/^##### (.*)$/gm, '<h5 class="markdown-h5"><strong>$1</strong></h5>')
        .replace(/^#### (.*)$/gm, '<h4 class="markdown-h4"><strong>$1</strong></h4>')
        .replace(/^### (.*)$/gm, '<h3 class="markdown-h3"><strong>$1</strong></h3>')
        .replace(/^## (.*)$/gm, '<h2 class="markdown-h2"><strong>$1</strong></h2>')
        .replace(/^# (.*)$/gm, '<h1 class="markdown-h1"><strong>$1</strong></h1>');

      // ===== 第五步：处理表格 =====
      result = result.replace(/(\|.*\|.*\n)+/g, (match) => {
        const lines = match.trim().split('\n');
        if (lines.length < 2) return match;

        const separatorLine = lines[1];
        if (!separatorLine.includes('---') && !separatorLine.includes(':')) {
          return match;
        }

        let tableHtml = '<table class="markdown-table"><thead>';
        const headers = lines[0].split('|').filter(cell => cell.trim() !== '');
        if (headers.length === 0) return match;

        tableHtml += '<tr>';
        headers.forEach(header => {
          tableHtml += `<th>${header.trim()}</th>`;
        });
        tableHtml += '</tr></thead><tbody>';

        for (let i = 2; i < lines.length; i++) {
          const cells = lines[i].split('|').filter(cell => cell.trim() !== '');
          if (cells.length > 0) {
            tableHtml += '<tr>';
            cells.forEach((cell, index) => {
              if (index < headers.length) {
                tableHtml += `<td>${cell.trim()}</td>`;
              }
            });
            for (let j = cells.length; j < headers.length; j++) {
              tableHtml += '<td></td>';
            }
            tableHtml += '</tr>';
          }
        }

        tableHtml += '</tbody></table>';
        return tableHtml;
      });

      // 处理不完整的表格
      result = result.replace(/\|[^|\n]*\|[^|\n]*$/gm, (match) => {
        return `<div class="markdown-table-incomplete">${match}<span class="cursor-blink">▋</span></div>`;
      });

      // 处理特殊格式：重要声明（以感叹号开头的加粗文本）
      result = result.replace(/^⚠️\s*\*\*([^*]+)\*\*[:：]/gm, '<div class="markdown-warning"><strong>⚠️ $1:</strong></div>');
      result = result.replace(/^❤️\s*\*\*([^*]+)\*\*[:：]/gm, '<div class="markdown-heart"><strong>❤️ $1:</strong></div>');

      // 处理带编号的段落标题（如 "|1.代谢综合征" 或 "###第一部分："）
      result = result.replace(/^(#{1,6})?([第一二三四五六七八九十]+[部分章节])[:：](.*)$/gm,
        '<h3 class="markdown-section-title"><strong>$2:</strong> $3</h3>');

      // 处理带分隔符的重要信息（如 "|2.延缓病情进展"）
      result = result.replace(/^\|(\d+)\.([^|]+)$/gm,
        '<div class="markdown-numbered-point"><span class="point-number">$1.</span><strong>$2</strong></div>');

      // 处理医学术语缩写（如 OSA(AHI>30) ）
      result = result.replace(/([A-Z]{2,})\(([^)]+)\)/g,
        '<span class="markdown-medical-term">$1<sub class="medical-abbr">($2)</sub></span>');

      // 引用块
      result = result.replace(/^>\s?(.*)$/gm, '<blockquote class="markdown-quote">$1</blockquote>');

      // 处理链接 [文本](链接) - 只处理完整的链接
      result = result.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" class="markdown-link">$1</a>');

      // 处理图片 ![alt](src) - 只处理完整的图片
      result = result.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" class="markdown-image">');

      // 处理带前缀的有序列表（支持中文数字和阿拉伯数字）
      result = result.replace(/^([一二三四五六七八九十\d]+)[\.、]\s+(.*)$/gm, '<li class="markdown-ol-item">$2</li>');

      // 有序列表（1. ...）
      result = result.replace(/^(\d+)\.\s+(.*)$/gm, '<li class="markdown-ol-item">$2</li>');
      // 用<ol>包裹连续的<li>
      result = result.replace(/(<li class="markdown-ol-item">.*?<\/li>\s*)+/g, match => `<ol class="markdown-ol">${match}</ol>`);

      // 无序列表（-、*、+）
      result = result.replace(/^[-*+]\s+(.*)$/gm, '<li class="markdown-ul-item">$1</li>');
      // 用<ul>包裹连续的<li>
      result = result.replace(/(<li class="markdown-ul-item">.*?<\/li>\s*)+/g, match => `<ul class="markdown-ul">${match}</ul>`);

      // 处理任务列表
      result = result.replace(/^[-*+]\s+\[([x\s])\]\s+(.*)$/gm, (match, checked, text) => {
        const isChecked = checked.toLowerCase() === 'x';
        return `<li class="markdown-task-item"><input type="checkbox" ${isChecked ? 'checked' : ''} disabled> ${text}</li>`;
      });

      // 处理特殊符号和emoji强调
      result = result.replace(/^([📊🔧❤️⚠️📋])\s+\*\*([^*]+)\*\*/gm,
        '<div class="markdown-emoji-title"><span class="emoji">$1</span><strong>$2</strong></div>');

      // ===== 第六步：处理加粗、斜体、删除线、行内代码 =====

      // 处理复杂的加粗组合（如 ***文本** ）
      result = result.replace(/\*\*\*([^*]+)\*\*/g, '<strong class="markdown-bold">$1</strong>');

      // 处理标准加粗、斜体、删除线、行内代码
      result = result
        .replace(/\*\*(.*?)\*\*/g, '<strong class="markdown-bold">$1</strong>')
        .replace(/__(.*?)__/g, '<strong class="markdown-bold">$1</strong>')
        .replace(/\*([^*\n]+)\*/g, '<em class="markdown-italic">$1</em>')
        .replace(/~~(.*?)~~/g, '<del class="markdown-strikethrough">$1</del>')
        .replace(/`([^`\n]+)`/g, '<code class="markdown-inline-code">$1</code>');

      // 分割线 - 支持多种格式
      result = result.replace(/^[-=]{3,}$/gm, '<hr class="markdown-hr">');
      result = result.replace(/^\#{4,}$/gm, '<hr class="markdown-hr-hash">');

      // 处理高亮文本（==文本==）
      result = result.replace(/==(.*?)==/g, '<mark class="markdown-highlight">$1</mark>');

      // 处理数学公式（可选）
      result = result.replace(/\$\$([^$]+)\$\$/g, '<div class="markdown-math-block">$$1$$</div>');
      result = result.replace(/\$([^$\n]+)\$/g, '<span class="markdown-math-inline">$$1$</span>');

      // 段落处理 - 针对医学报告优化
      const lines = result.split('\n');
      const processedLines = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        const prevLine = i > 0 ? lines[i - 1].trim() : '';

        // 跳过空行
        if (!line) {
          processedLines.push('');
          continue;
        }

        // 检查是否为块级元素（标题、HR、表格、列表等）
        const isBlockElement = line.match(/^<(h[1-6]|hr|table|ol|ul|pre|div|blockquote)/);
        const isClosingTag = line.match(/^<\/(h[1-6]|hr|table|ol|ul|pre|div|blockquote)/);
        const isListItem = line.match(/^<li/);
        const isTableRow = line.match(/^<tr/);

        // 块级元素直接添加，不包装在段落中
        if (isBlockElement || isClosingTag || isListItem || isTableRow) {
          processedLines.push(line);
        }
        // 普通文本行，需要包装在段落中
        else if (!line.startsWith('<')) {
          // 检查前一行是否也是普通文本，如果是则连接，否则开始新段落
          const prevIsText = prevLine && !prevLine.startsWith('<') && !prevLine.endsWith('>');

          if (prevIsText) {
            processedLines.push(line); // 继续当前段落
          } else {
            processedLines.push(`<p class="markdown-p">${line}</p>`); // 新段落
          }
        }
        else {
          processedLines.push(line);
        }
      }

      result = processedLines.join('\n');

      // 清理多余的空段落
      result = result.replace(/<p class="markdown-p">\s*<\/p>/g, '');

      // 确保标题元素前后有适当的换行
      result = result.replace(/(<h[1-6][^>]*>)/g, '<br>$1');  // 标题前换行
      result = result.replace(/(<\/h[1-6]>)/g, '$1<br>');     // 标题后换行
      result = result.replace(/(<hr[^>]*>)/g, '<br>$1<br>');  // 分割线前后换行

      // 清理多余的连续<br>标签
      result = result.replace(/(<br>\s*){3,}/g, '<br><br>'); // 最多保留两个连续的<br>
      result = result.replace(/^<br>|<br>$/g, ''); // 移除开头和结尾的<br>

      // 智能换行处理 - 只在非HTML标签的地方添加<br>
      result = result.replace(/\n(?![<\n])/g, '<br>');

      // ===== 最后一步：恢复代码块 =====
      codeBlocks.forEach((block, index) => {
        result = result.replace(`__CODE_BLOCK_${index}__`, block);
      });

      // 如果文本以不完整的markdown语法结尾，添加光标效果
      if (text.endsWith('**') || text.endsWith('__') || text.endsWith('*') ||
        text.endsWith('`') || text.endsWith('#') || text.endsWith('|')) {
        result += '<span class="cursor-blink">▋</span>';
      }


      return result;
    },

    // 将Markdown格式转换为纯文本
    convertMarkdownToPlainText(text) {
      if (!text) return '';

      let result = text;

      // 移除代码块（先处理，避免内容被其他规则影响）
      result = result.replace(/```[\s\S]*?```/g, (match) => {
        // 提取代码内容，移除语言标识
        const content = match.replace(/```\w*\n?/, '').replace(/```$/, '');
        return content.trim();
      });

      // 移除行内代码标记
      result = result.replace(/`([^`]+)`/g, '$1');

      // 移除标题标记
      result = result.replace(/^#{1,6}\s+(.*)$/gm, '$1');

      // 移除加粗标记
      result = result.replace(/\*\*(.*?)\*\*/g, '$1');
      result = result.replace(/__(.*?)__/g, '$1');

      // 移除斜体标记
      result = result.replace(/\*([^*\n]+)\*/g, '$1');
      result = result.replace(/_([^_\n]+)_/g, '$1');

      // 移除删除线标记
      result = result.replace(/~~(.*?)~~/g, '$1');

      // 移除高亮标记
      result = result.replace(/==(.*?)==/g, '$1');

      // 移除链接，保留文本
      result = result.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

      // 移除图片，保留alt文本
      result = result.replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1');

      // 移除引用标记
      result = result.replace(/^>\s?/gm, '');

      // 处理列表项，移除标记但保留内容
      result = result.replace(/^[-*+]\s+/gm, '• '); // 无序列表改为点符号
      result = result.replace(/^\d+\.\s+/gm, ''); // 有序列表移除编号

      // 处理任务列表
      result = result.replace(/^[-*+]\s+\[([x\s])\]\s+/gm, (match, checked) => {
        return checked.toLowerCase() === 'x' ? '✓ ' : '○ ';
      });

      // 处理表格 - 简单转换为制表符分隔
      result = result.replace(/\|([^|\n]+)\|/g, (match, content) => {
        return content.split('|').map(cell => cell.trim()).join('\t');
      });

      // 移除表格分隔行
      result = result.replace(/^\|?[-:|\s]+\|?\s*$/gm, '');

      // 移除分割线
      result = result.replace(/^---+$/gm, '');

      // 清理多余空行（保留双换行作为段落分隔）
      result = result.replace(/\n{3,}/g, '\n\n');

      // 移除行首行尾空格
      result = result.replace(/^\s+|\s+$/gm, '');

      // 移除开头和结尾的空行
      result = result.trim();

      return result;
    },

    // 复制消息内容
    async copyMessage(text) {
      try {
        // 将Markdown格式转换为纯文本
        const plainText = this.convertMarkdownToPlainText(text);

        // 使用Clipboard API复制文本
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(plainText);
        } else {
          // 降级方案：使用传统方法
          const textArea = document.createElement('textarea');
          textArea.value = plainText;
          textArea.style.position = 'fixed';
          textArea.style.left = '-9999px';
          textArea.style.top = '-9999px';
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
          } catch (err) {
            return;
          } finally {
            document.body.removeChild(textArea);
          }
        }

        // 显示成功提示
        this.$toast?.showGreen('内容已复制到剪贴板');
      } catch (error) {
        // 显示失败提示
        this.$toast?.showRed('复制失败，请重试');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .report-container {
    padding: 0 !important;
  }

  .no-print {
    display: none !important;
  }

  // 打印时隐藏AI悬浮按钮和对话框
  .ai-chat-floating-button,
  .ai-chat-panel {
    display: none !important;
  }

  /* 打印页码样式 */
  @page {
   
    size: A4;
    
    @bottom-center {
      content: "第 " counter(page) " 页";
      font-family: "SimSun", serif;
      font-size: 12px;
      color: #333;
    }
  }
  
  /* 确保页面内容区域留出页脚空间 */
  .report-container,
  .report-compression {
    padding-bottom: 60px !important;
  }
}

.report {
  width: 100%;

  &-container {
    left: top;
    width: rem(1050);
    padding: 0;
    margin: 0 auto;

    &-qr-code {
      display: flex;
      // margin-top: rem(10);
      width: 100%;

      justify-content: center;

      &-img {
        width: rem(80);
        height: rem(80);
      }
    }
  }

  &-compression {
    left: top;
    width: rem(726);
    padding: 0;
    margin: 0 auto;
  }

  &-warning {
    margin-top: rem(10);
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    right: 0;
    text-align: center;
  }
}
</style>

<style lang="scss">
.el-message-box__message p {
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}

// AI 会话悬浮按钮样式
.ai-chat-floating-button {
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #4F8CFF 0%, #6EE7B7 100%);
  box-shadow: 0 8px 32px rgba(79, 140, 255, 0.25), 0 1.5px 6px rgba(0, 0, 0, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: box-shadow 0.2s, transform 0.2s, background 0.2s;
  user-select: none;
  border: none;
  outline: none;
  backdrop-filter: blur(4px);
  flex-direction: column;
  gap: 2px;

  .ai-icon {
    width: 32px;
    height: 32px;
    display: block;
  }

  .ai-chat-label {
    margin-top: 2px;
    font-size: 13px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    pointer-events: none;
    user-select: none;
    line-height: 1.1;
    text-align: center;
    white-space: nowrap;
  }

  &:hover,
  &:focus {
    box-shadow: 0 12px 40px rgba(79, 140, 255, 0.35), 0 2px 8px rgba(0, 0, 0, 0.12);
    transform: translateY(-4px) scale(1.08);
    background: linear-gradient(135deg, #6EE7B7 0%, #4F8CFF 100%);
  }

  &:active {
    transform: scale(0.98);
    box-shadow: 0 4px 16px rgba(79, 140, 255, 0.18);
  }
}

@media (max-width: 600px) {
  .ai-chat-floating-button {
    width: 52px;
    height: 52px;
    bottom: 16px;
    right: 16px;

    .ai-icon {
      width: 20px;
      height: 20px;
    }

    .ai-chat-label {
      font-size: 11px;
    }
  }
}

// AI会话对话框样式 - 增加宽度
.ai-chat-panel {
  position: fixed;
  bottom: 120px;
  right: 32px;
  width: 520px; // 从400px增加到520px
  height: 600px;
  z-index: 9999;
  border-radius: 24px;
  box-shadow: 0 8px 40px rgba(79, 140, 255, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: visible;
  background: linear-gradient(135deg, #fafdff 0%, #e9f7fe 100%);
  transform-origin: bottom right;
  animation: slideInFromBottom 0.3s ease-out;
  pointer-events: auto;
  transition: all 0.4s ease-in-out;

  &.draggable-dialog {
    cursor: move;
    user-select: none;

    &:hover {
      box-shadow: 0 12px 48px rgba(79, 140, 255, 0.18), 0 4px 12px rgba(0, 0, 0, 0.12);
    }
  }

  // 放大状态下的样式
  &.zoomed {
    width: 800px !important;
    height: 750px !important;
    transform-origin: center;
    box-shadow: 0 16px 64px rgba(79, 140, 255, 0.25), 0 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 28px;

    .ai-chat-dialog-header-simplified {
      padding: 40px 40px 24px 40px;

      .ai-avatar {
        width: 56px;
        height: 56px;
      }

      .ai-title {
        font-size: 24px;
      }

      .ai-desc {
        font-size: 16px;
      }
    }

    .chat-messages {
      padding: 32px 40px 16px 40px;

      .message .message-content {
        font-size: 17px;
        padding: 16px 20px;
      }
    }

    .common-questions {
      padding: 20px 40px 12px 40px;

      .questions-title {
        font-size: 15px;
      }

      .question-button {
        padding: 12px 16px;
        font-size: 14px;
      }
    }

    .chat-input-area {
      padding: 20px 40px 32px 40px;

      .input-wrapper {
        height: 48px;
        border-radius: 24px;

        .chat-input {
          font-size: 16px;
          padding: 12px 20px;
        }

        .send-button {
          font-size: 16px;
          padding: 12px 20px;
          min-width: 80px;
        }
      }
    }
  }
}

@keyframes slideInFromBottom {
  from {
    transform: translateY(100%) scale(0.8);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

// 简化后的聊天容器
.ai-chat-container-simplified {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #fafdff 0%, #e9f7fe 100%);
  border-radius: 24px;
  overflow: hidden;
  pointer-events: auto;
}

// 右上角关闭按钮
.ai-close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(79, 140, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  color: #666;
  transition: all 0.2s;
  backdrop-filter: blur(4px);
  pointer-events: auto; // 关闭按钮必须允许交互

  &:hover {
    background: rgba(255, 255, 255, 1);
    color: #4F8CFF;
    border-color: #4F8CFF;
    transform: scale(1.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

// 放大镜按钮
.ai-zoom-button {
  position: absolute;
  top: 16px;
  right: 56px; // 在关闭按钮左侧
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(79, 140, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  color: #666;
  transition: all 0.2s;
  backdrop-filter: blur(4px);
  pointer-events: auto;

  &:hover {
    background: rgba(255, 255, 255, 1);
    color: #6EE7B7;
    border-color: #6EE7B7;
    transform: scale(1.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

// 简化的头部样式
.ai-chat-dialog-header-simplified {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 32px 32px 20px 32px;
  background: linear-gradient(90deg, #4F8CFF 0%, #6EE7B7 100%);
  border-radius: 24px 24px 0 0;
  box-shadow: 0 2px 12px rgba(79, 140, 255, 0.08);
  pointer-events: none; // 头部区域不阻止拖拽
}

.ai-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(79, 140, 255, 0.12);
}

.ai-title-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ai-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff !important;
  letter-spacing: 1px;
  margin-bottom: 2px;
  pointer-events: none;
}

.ai-desc {
  font-size: 15px;
  color: #e0f7fa !important;
  opacity: 0.85;
  pointer-events: none;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px 32px 12px 32px;
  background: transparent;
  border: none;
  border-radius: 0;
  margin-bottom: 0;
  pointer-events: auto;

  .message {
    display: flex;
    margin-bottom: 18px;
    pointer-events: auto;

    &.user .message-content {
      background: linear-gradient(135deg, #4F8CFF 0%, #6EE7B7 100%);
      color: #fff !important;
      border-radius: 20px 20px 8px 20px;
      box-shadow: 0 2px 8px rgba(79, 140, 255, 0.10);
    }

    &.ai .message-content {
      background: #fff;
      color: #333 !important;
      border: 1px solid #e9ecef;
      border-radius: 20px 20px 20px 8px;
      box-shadow: 0 2px 8px rgba(79, 140, 255, 0.06);
    }

    &.system .message-content {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      color: #495057 !important;
      border: 1px solid #dee2e6;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      font-size: 13px;
      line-height: 1.5;
      max-width: 95%;
      word-break: break-word;

      .message-rich-text {
        max-height: 400px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 2px;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          margin: 8px 0 4px 0;
        }

        p {
          margin: 4px 0;
        }
      }
    }

    .message-content {
      position: relative;
      padding: 14px 18px;
      font-size: 16px;
      min-width: 60px;
      max-width: 80%; // 增加最大宽度以适应更宽的容器
      transition: box-shadow 0.2s;
      pointer-events: auto;
    }

    // 复制按钮样式
    .copy-button {
      position: absolute;
      top: 8px;
      right: 8px;
      padding: 4px 8px;
      background: rgba(255, 255, 255, 0.9);
      border: 1px solid rgba(79, 140, 255, 0.2);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      opacity: 0.8; // 改为可见
      transition: all 0.2s ease;
      z-index: 10;
      pointer-events: auto;
      font-size: 12px;
      color: #666;

      i {
        margin-right: 4px;
        font-size: 12px;
        display: inline-block;
      }

      span {
        font-size: 12px;
      }

      &:hover {
        background: rgba(255, 255, 255, 1);
        border-color: #4F8CFF;
        color: #4F8CFF;
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }
    }

    // 消息悬停时显示复制按钮
    .message.ai:hover .copy-button,
    .message.system:hover .copy-button {
      opacity: 1;
    }

    .message-text {
      color: inherit !important;
      line-height: 1.6;
    }

    .message-time {
      font-size: 12px;
      opacity: 0.5;
      margin-top: 6px;
      text-align: right;
      color: inherit !important;
    }
  }
}

// 常见问题快捷按钮样式 - 优化布局
.common-questions {
  padding: 16px 32px 8px 32px;
  background: transparent;
  border-top: 1px solid rgba(79, 140, 255, 0.1);

  .questions-title {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
    font-weight: 600;
  }

  .questions-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px; // 增加间距
    justify-content: flex-start; // 确保按钮从左开始排列

    .question-button {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 10px 14px; // 增加内边距
      background: #fff;
      border: 1px solid #e3eaf3;
      border-radius: 16px;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.2s;
      color: #555;
      font-weight: 500;
      flex: 0 0 auto; // 防止按钮被拉伸
      min-width: 0; // 允许文字自动换行
      pointer-events: auto; // 问题按钮允许交互

      .question-icon {
        font-size: 14px;
        line-height: 1;
        flex-shrink: 0; // 防止图标被压缩
      }

      .question-text {
        white-space: nowrap;
        line-height: 1;
      }

      &:hover:not(:disabled) {
        background: linear-gradient(135deg, #4F8CFF 0%, #6EE7B7 100%);
        color: #fff;
        border-color: transparent;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(79, 140, 255, 0.15);
      }

      &:disabled {
        background: #f5f5f5;
        color: #ccc;
        cursor: not-allowed;
        border-color: #eee;
      }
    }
  }
}

// 修复输入区域样式 - 使用原生input而不是el-input
.chat-input-area {
  padding: 16px 32px 24px 32px;
  background: transparent;
  border-radius: 0 0 24px 24px;
  position: relative;
  z-index: 10002;
  pointer-events: auto;

  .input-wrapper {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #e3eaf3;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(79, 140, 255, 0.08);
    overflow: hidden;
    height: 40px; // 固定高度
    pointer-events: auto; // 输入区域允许交互

    .chat-input {
      flex: 1;
      border: none;
      outline: none;
      padding: 8px 16px;
      font-size: 14px;
      background: transparent;
      color: #333;
      height: 100%;
      min-width: 0; // 确保输入框可以收缩
      cursor: text; // 输入框显示文本光标

      &::placeholder {
        color: #999;
      }

      &:disabled {
        background: #f5f5f5;
        color: #ccc;
      }
    }

    .send-button {
      background: linear-gradient(90deg, #4F8CFF 0%, #6EE7B7 100%);
      color: #fff;
      border: none;
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
      border-radius: 0 20px 20px 0;
      height: 100%;
      min-width: 60px; // 确保按钮有最小宽度
      flex-shrink: 0; // 防止按钮被压缩
      pointer-events: auto; // 发送按钮允许交互

      &:hover:not(:disabled) {
        background: linear-gradient(90deg, #6EE7B7 0%, #4F8CFF 100%);
        box-shadow: 0 2px 8px rgba(79, 140, 255, 0.2);
      }

      &:disabled {
        background: #ddd;
        color: #999;
        cursor: not-allowed;
      }
    }
  }
}

@media (max-width: 600px) {
  .ai-chat-panel {
    width: calc(100vw - 32px);
    right: 16px;
    bottom: 80px;
    height: 500px;
    border-radius: 16px;
  }

  .ai-chat-container-simplified {
    border-radius: 16px;
  }

  .ai-chat-dialog-header-simplified,
  .chat-input-area,
  .common-questions {
    padding-left: 16px; // 移动端适当增加内边距
    padding-right: 16px;
  }

  .chat-messages {
    padding-left: 16px;
    padding-right: 16px;
  }

  .common-questions .questions-buttons {
    gap: 8px; // 移动端减少间距

    .question-button {
      padding: 8px 10px; // 移动端减少内边距

      .question-text {
        font-size: 12px;
      }
    }
  }
}

// 打字指示器动画
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    width: 6px;
    height: 6px;
    background: #999;
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: -0.32s;
    }

    &:nth-child(2) {
      animation-delay: -0.16s;
    }

    &:nth-child(3) {
      animation-delay: 0;
    }
  }
}

@keyframes typing {

  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

// Markdown渲染样式 - 支持流式渲染
.message-rich-text {
  line-height: 1.6;
  font-size: 14px; // 设置基础字体大小
  color: #333;

  // 标题样式
  .markdown-h1,
  .markdown-h2,
  .markdown-h3,
  .markdown-h4,
  .markdown-h5,
  .markdown-h6 {
    margin: 16px 0 8px 0;
    color: #2c3e50;
    font-weight: bold;
  }

  .markdown-h1 {
    font-size: 18px;
    border-bottom: 2px solid #4F8CFF;
    padding-bottom: 4px;
  }

  .markdown-h2 {
    font-size: 17px;
    border-bottom: 1px solid #6EE7B7;
    padding-bottom: 2px;
  }

  .markdown-h3 {
    font-size: 16px;
    color: #4F8CFF;
  }

  .markdown-h4 {
    font-size: 15px;
    color: #6EE7B7;
  }

  .markdown-h5 {
    font-size: 14px;
  }

  .markdown-h6 {
    font-size: 13px;
  }

  // 表格样式
  .markdown-table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    border: 1px solid #e1e8ed;
    border-radius: 8px;
    overflow: hidden;

    th,
    td {
      padding: 12px 8px;
      text-align: left;
      border-bottom: 1px solid #e1e8ed;
      border-right: 1px solid #e1e8ed;
      font-size: 14px;

      &:last-child {
        border-right: none;
      }
    }

    th {
      background: linear-gradient(90deg, #4F8CFF 0%, #6EE7B7 100%);
      color: white;
      font-weight: 600;
      text-align: center;
    }

    tr:nth-child(even) {
      background-color: #f8fafc;
    }

    tr:hover {
      background-color: #e3f2fd;
    }
  }

  // 代码块样式
  pre {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 16px;
    margin: 12px 0;
    overflow-x: auto;

    code {
      background: transparent;
      padding: 0;
      border: none;
      font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
      font-size: 14px;
      line-height: 1.4;
    }
  }

  // 行内代码样式
  .markdown-inline-code {
    background: #f1f3f4;
    color: #d73a49;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 14px;
  }

  // 列表样式
  .markdown-ul,
  .markdown-ol {
    margin: 12px 0;
    padding-left: 24px;

    .markdown-ul-item,
    .markdown-ol-item {
      margin: 6px 0;
      line-height: 1.5;
    }
  }

  // 任务列表样式
  .markdown-task-item {
    list-style: none;
    margin: 6px 0;

    input[type="checkbox"] {
      margin-right: 8px;
    }
  }

  // 引用块样式
  .markdown-quote {
    border-left: 4px solid #4F8CFF;
    margin: 16px 0;
    padding: 8px 16px;
    background: #f8fafc;
    font-style: italic;
    color: #555;
  }

  // 文本样式
  .markdown-bold {
    font-weight: 700;
    color: #2c3e50;
  }

  .markdown-italic {
    font-style: italic;
    color: #555;
  }

  .markdown-strikethrough {
    text-decoration: line-through;
    color: #999;
  }

  .markdown-highlight {
    background: #fff3cd;
    padding: 2px 4px;
    border-radius: 2px;
  }

  // 分割线样式
  .markdown-hr {
    border: none;
    height: 2px;
    background: linear-gradient(90deg, #4F8CFF 0%, #6EE7B7 100%);
    margin: 24px 0;
    border-radius: 1px;
  }

  // 链接样式
  a {
    color: #4F8CFF;
    text-decoration: none;
    border-bottom: 1px dotted #4F8CFF;

    &:hover {
      color: #6EE7B7;
      border-bottom-color: #6EE7B7;
    }
  }

  // 图片样式
  .markdown-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 8px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  // 段落样式
  .markdown-p {
    margin: 12px 0;
    line-height: 1.6;
  }

  // 新增特殊格式样式

  // 警告和心形提示
  .markdown-warning {
    background: linear-gradient(90deg, #fff3cd 0%, #ffeeba 100%);
    border: 1px solid #ffc107;
    border-radius: 8px;
    padding: 12px 16px;
    margin: 16px 0;
    color: #856404;
    font-weight: 600;

    strong {
      color: #721c24;
    }
  }

  .markdown-heart {
    background: linear-gradient(90deg, #f8d7da 0%, #f5c6cb 100%);
    border: 1px solid #f28ba8;
    border-radius: 8px;
    padding: 12px 16px;
    margin: 16px 0;
    color: #721c24;
    font-weight: 600;
  }

  // 章节标题样式
  .markdown-section-title {
    background: linear-gradient(90deg, #e3f2fd 0%, #bbdefb 100%);
    border-left: 4px solid #4F8CFF;
    padding: 16px 20px;
    margin: 20px 0;
    border-radius: 0 8px 8px 0;
    font-size: 18px;

    strong {
      color: #1565c0;
    }
  }

  // 编号要点样式
  .markdown-numbered-point {
    display: flex;
    align-items: flex-start;
    margin: 12px 0;
    padding: 12px 16px;
    background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 8px;
    border-left: 3px solid #6EE7B7;

    .point-number {
      color: #4F8CFF;
      font-weight: bold;
      font-size: 16px;
      margin-right: 12px;
      flex-shrink: 0;
      background: #fff;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #4F8CFF;
    }

    strong {
      color: #2c3e50;
      flex: 1;
      line-height: 1.5;
    }
  }

  // 医学术语样式
  .markdown-medical-term {
    color: #4F8CFF;
    font-weight: 600;
    position: relative;

    .medical-abbr {
      font-size: 11px;
      color: #666;
      font-weight: normal;
      margin-left: 2px;
    }
  }

  // emoji标题样式
  .markdown-emoji-title {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    margin: 16px 0;
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
    border: 1px solid #e3eaf3;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(79, 140, 255, 0.08);

    .emoji {
      font-size: 24px;
      line-height: 1;
    }

    strong {
      color: #2c3e50;
      font-size: 16px;
    }
  }

  // 特殊分割线样式
  .markdown-hr-hash {
    border: none;
    height: 1px;
    background: repeating-linear-gradient(90deg,
        #4F8CFF 0px,
        #4F8CFF 8px,
        transparent 8px,
        transparent 16px);
    margin: 24px 0;
  }

  // 光标闪烁动画（用于流式渲染）
  .cursor-blink {
    animation: blink 1.2s infinite;
    color: #4F8CFF;
    font-weight: bold;
  }

  @keyframes blink {

    0%,
    50% {
      opacity: 1;
    }

    51%,
    100% {
      opacity: 0;
    }
  }

  // 不完整表格样式
  .markdown-table-incomplete {
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 8px 0;
    font-size: 14px;
    color: #666;
  }

  // 增强有序列表样式（支持中文数字）
  .markdown-ol {
    counter-reset: chinese-counter;

    .markdown-ol-item {
      position: relative;
      padding-left: 32px;

      &:before {
        counter-increment: chinese-counter;
        content: counter(chinese-counter) ".";
        position: absolute;
        left: 0;
        top: 0;
        color: #4F8CFF;
        font-weight: bold;
        width: 24px;
      }
    }
  }
}
</style>
